// 群发，获客海报，预约插件，获客文章，扫码支付，活动插件，房产插件放到应用中心
// 分销放到商城去
export default [{
  path: '/',
  redirect: '/survey',
  hidden: true // 是否展示在侧边栏的菜单里
},
//  概览
{
  path: '/survey',
  component: 'Layout',
  redirect: '/survey/index',
  meta: {
    menuName: 'Survey', // 一级菜单标题
    icon: 'icon-gaikuang' // 一级菜单的图标
  },
  children: [{
    path: 'index',
    name: 'Survey',
    component: '/survey/index',
    meta: {
      keepAlive: false, // 是否缓存页面
      refresh: false,
      title: '', // 页面头部的标题
      isOnly: true, // 单独页面
      auth: ['view', 'add', 'edit', 'del', 'outport'], // 单独页面按钮操作权限
      pagePermission: []
    }
  }]
},
// 名片
{
  path: '/businessCard',
  component: 'Layout',
  redirect: '/businessCard/staffCard',
  meta: { // 所有要展示在菜单里的路由都添加在这边
    menuName: 'BusinessCard', // 一级菜单标题
    icon: 'icon-mingpian', // 一级菜单的图标
    subNavName: [{
      name: 'CardInfo', // 二级菜单的下拉的标题
      url: [{
        name: 'StaffCard', // 三级菜单的标题
        url: '/businessCard/staffCard' // 三级菜单的路由
      },
      {
        name: 'ImpressionLabel', // 三级菜单的标题
        url: '/businessCard/tag' // 三级菜单的路由
      }
      ]
    },
    {
      name: 'CardSetting',
      url: [{
        name: 'ExemptionPassword',
        url: '/businessCard/exemptionPwd'
      },
      {
        name: 'MobileSetting',
        url: '/businessCard/mobileSetting'
      },
      {
        name: 'MediaSetting',
        url: '/businessCard/mediaSetting'
      },
      {
        name: 'CardSetting',
        url: '/businessCard/cardSetting'
      }
      ]
    }
    ]
  },
  children: [ // 子菜单路由表
    // 名片管理
    {
      path: 'staffCard',
      name: 'StaffCard',
      component: '/businessCard/manage/staffCard',
      meta: {
        keepAlive: true,
        title: 'CardManage', // 页面头部的标题
        isOnly: false, // 多页面
        auth: [],
        pagePermission: [ // 页面权限
          {
            title: 'StaffCard',
            index: 0,
            auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
          }
        ]
      }
    },
    // 名片编辑
    {
      path: 'editCard',
      name: 'EditCard',
      component: '/businessCard/manage/editCard',
      meta: {
        refresh: false,
        title: 'CardManage', // 页面头部的标题
        isOnly: false, // 多页面
        auth: [],
        pagePermission: [ // 页面权限
          {
            title: 'EditCard',
            index: 0,
            auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
          }
        ]
      }
    },
    // 印象标签
    {
      path: 'tag',
      name: 'ImpressionLabel',
      component: '/businessCard/manage/tag',
      meta: {
        keepAlive: true,
        title: 'CardManage',
        isOnly: false,
        auth: [],
        pagePermission: [{
          title: 'ImpressionLabel',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
        }]
      }
    },
    // 免审口令
    {
      path: 'exemptionPwd',
      name: 'ExemptionPassword',
      component: '/businessCard/set/exemptionPwd',
      meta: {
        keepAlive: true,
        refresh: false,
        title: 'CardManage',
        isOnly: false,
        auth: [],
        pagePermission: [{
          title: 'ExemptionPassword',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
        }]
      }
    },
    // 手机端设置
    {
      path: 'mobileSetting',
      name: 'MobileSetting',
      component: '/businessCard/set/mobileSetting',
      meta: {
        keepAlive: true,
        refresh: false,
        title: 'CardManage',
        isOnly: false,
        auth: [],
        pagePermission: [{
          title: 'MobileSetting',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
        }]
      }
    },
    // 媒体设置
    {
      path: 'mediaSetting',
      name: 'MediaSetting',
      component: '/businessCard/set/mediaSetting',
      meta: {
        keepAlive: true,
        refresh: false,
        title: 'CardManage',
        isOnly: false,
        auth: [],
        pagePermission: [{
          title: 'MediaSetting',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
        }]
      }
    },
    // 名片设置
    {
      path: 'cardSetting',
      name: 'CardSetting',
      component: '/businessCard/set/cardSetting',
      meta: {
        keepAlive: true,
        refresh: false,
        title: 'CardManage',
        isOnly: false,
        auth: [],
        pagePermission: [{
          title: 'CardSetting',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
        }]
      }
    }
  ]
},
// 商城
{
  path: '/malls',
  component: 'Layout',
  redirect: '/malls/list',
  meta: { // 所有要展示在菜单里的路由都添加在这边
    menuName: 'Malls', // 一级菜单标题
    icon: 'icon-gouwudai', // 一级菜单的图标
    subNavName: [{
      name: 'MallsManage', // 二级菜单的下拉的标题
      url: [
        // {
        //   name: 'MallsTemplate', // 三级菜单的标题
        //   url: '/malls/template' // 三级菜单的路由
        // },
        {
          name: 'GoodsList', // 三级菜单的标题
          url: '/malls/list' // 三级菜单的路由
        },
        {
          name: 'IntegralList', // 三级菜单的标题
          url: '/malls/IntegralList' // 三级菜单的路由
        },
        {
          name: 'GoodsClassify', // 三级菜单的标题
          url: '/malls/classify' // 三级菜单的路由
        },
        {
          name: 'GoodsParamConfigList',
          url: '/malls/paramconfiglist'
        },
        {
          name: 'freightList',
          url: '/malls/freightlist'
        }
      ]
    },
    {
      name: 'OrderManage',
      url: [{
        name: 'OrderManage',
        url: '/malls/orderManage'
      },
      {
        name: 'RefundManage',
        url: '/malls/refundManage'
      }
      ]
    },
    {
      name: 'MarketingManage',
      url: [{
        name: 'AssembleList',
        url: '/malls/assemble'
      },
      {
        name: 'RedPackit',
        url: '/malls/redPackit'
      }
      ]
    },
    {
      name: 'MallsSet',
      url: [{
        name: 'DealSet',
        url: '/malls/dealSet'
      },
      {
        name: 'VirtualPaymentSet',
        url: '/malls/virtualPayment'
      },
      {
        name: 'StaffChoiceGoods',
        url: '/malls/staffGoods'
      },
      {
        name: 'PaymentSetting',
        url: '/malls/paymentSetting'
      },
      {
        name: 'MallsBanner',
        url: '/malls/banner'
      }
      ]
    },
    {
      name: 'Distributioninfo',
      url: [{
        name: 'ProfitInfo',
        url: '/malls/profit'
      },
      {
        name: 'CommissionInfo',
        url: '/malls/commission'
      },
      {
        name: 'TakeCashInfo',
        url: '/malls/cash'
      },
      {
        name: 'CashSet',
        url: '/malls/cashSet'
      },
      {
        name: 'DistributionRelation',
        url: '/malls/relation'
      },
      {
        name: 'DistributionSetting',
        url: '/malls/disSet'
      },
      {
        name: 'DistributionAudit',
        url: '/malls/Audit'
      }
      ]
    }
    ]
  },
  children: [ // 子菜单路由表
    // 商品列表
    {
      path: 'list',
      name: 'GoodsList',
      component: '/malls/goods/list',
      meta: {
        keepAlive: true,
        refresh: false,
        title: 'MallsSet', // 页面头部的标题
        isOnly: false, // 多页面
        auth: [],
        pagePermission: [ // 页面权限
          {
            title: 'GoodsList',
            index: 0,
            auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
          }
        ]
      }
    },
    // 积分商品
    {
      path: 'IntegralList',
      name: 'IntegralList',
      component: '/malls/goods/IntegralList',
      meta: {
        keepAlive: true,
        refresh: false,
        title: 'IntegralList', // 页面头部的标题
        isOnly: false, // 多页面
        auth: [],
        pagePermission: [ // 页面权限
          {
            title: 'IntegralList',
            index: 0,
            auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
          }
        ]
      }
    },
    // 商品分类
    {
      path: 'classify',
      name: 'GoodsClassify',
      component: '/malls/goods/classify',
      meta: {
        keepAlive: true,
        refresh: false,
        title: 'MallsSet',
        isOnly: false,
        auth: [],
        pagePermission: [{
          title: 'GoodsClassify',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
        }]
      }
    },
    // 参数管理
    {
      path: 'paramconfiglist',
      name: 'GoodsParamConfigList',
      component: '/malls/goods/paramconfiglist',
      meta: {
        keepAlive: true,
        refresh: false,
        title: 'MallsSet',
        isOnly: false,
        auth: [],
        pagePermission: [{
          title: 'GoodsParamConfigList',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
        }]
      }
    },
    // 运费模板
    {
      path: 'freightlist',
      name: 'freightList',
      component: '/malls/goods/freightlist',
      meta: {
        keepAlive: true,
        refresh: false,
        title: 'MallsSet',
        isOnly: false,
        auth: [],
        pagePermission: [{
          title: 'freightList',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
        }]
      }
    },
    // 运费模板新增
    {
      path: 'freightadd',
      name: 'freightAdd',
      component: '/malls/goods/freightadd',
      meta: {
        keepAlive: true,
        refresh: false,
        title: 'MallsSet',
        isOnly: false,
        auth: [],
        pagePermission: [{
          title: 'freightAdd',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
        }]
      }
    },
    {
      path: 'addSpecs',
      name: 'AddSpecs',
      component: '/malls/goods/addSpecs',
      meta: {
        title: 'MallsSet',
        isOnly: false,
        auth: [],
        pagePermission: [{
          title: 'SpecsClassify',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
        }]
      }
    },
    // 添加参数
    {
      path: 'paramconfigadd',
      name: 'paramConfigAdd',
      component: '/malls/goods/paramconfigadd',
      meta: {
        title: 'MallsSet',
        isOnly: false,
        auth: [],
        pagePermission: [{
          title: 'paramConfigAdd',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
        }]
      }
    },
    // 添加分类
    {
      path: 'addClassify',
      name: 'SpecsClassify',
      component: '/malls/goods/addClassify',
      meta: {
        title: 'MallsSet',
        isOnly: false,
        auth: [],
        pagePermission: [{
          title: 'AddClassify',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
        }]
      }
    },
    // 商品编辑
    {
      path: 'edit',
      name: 'GoodsEdit',
      component: '/malls/goods/edit',
      meta: {
        title: 'MallsSet',
        isOnly: false,
        auth: [],
        pagePermission: [{
          title: 'GoodsEdit',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
        }]
      }
    },
    // 积分商品编辑
    {
      path: 'integraledit',
      name: 'GoodsEdit',
      component: '/malls/goods/integraledit',
      meta: {
        title: 'MallsSet',
        isOnly: false,
        auth: [],
        pagePermission: [{
          title: 'GoodsEdit',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
        }]
      }
    },
    // 订单管理
    {
      path: 'orderManage',
      name: 'OrderManage',
      component: '/malls/order/manage',
      meta: {
        keepAlive: true,
        title: 'MallsSet',
        isOnly: false,
        auth: [],
        pagePermission: [{
          title: 'OrderManage',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
        }]
      }
    },
    // 订单详情
    {
      path: 'orderDetail',
      name: 'OrderDetail',
      component: '/malls/order/detail',
      meta: {
        title: 'MallsSet',
        isOnly: false,
        auth: [],
        pagePermission: [{
          title: 'OrderDetail',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
        }]
      }
    },
    // 退款管理
    {
      path: 'refundManage',
      name: 'RefundManage',
      component: '/malls/order/refund',
      meta: {
        keepAlive: true,
        title: 'MallsSet',
        isOnly: false,
        auth: [],
        pagePermission: [{
          title: 'RefundManage',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
        }]
      }
    },
    // 最新开团
    {
      path: 'newAssemble',
      name: 'NewAssemble',
      component: '/malls/marketing/newAssemble',
      meta: {
        keepAlive: true,
        title: 'MallsSet',
        isOnly: false,
        auth: [],
        pagePermission: [{
          title: 'NewAssemble',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
        }]
      }
    },
    // 拼团信息
    {
      path: 'assemble',
      name: 'AssembleList',
      component: '/malls/marketing/assemble',
      meta: {
        title: 'MallsSet',
        isOnly: false,
        auth: [],
        pagePermission: [{
          title: 'AssembleList',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
        }]
      }
    },
    // 拼团管理（添加拼团规则）AssembleManage
    {
      path: 'assembleManage',
      name: 'AssembleManage',
      component: '/malls/marketing/assembleManage',
      meta: {
        title: 'MallsSet',
        isOnly: false,
        auth: [],
        pagePermission: [{
          title: 'AssembleManage',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
        }]
      }
    },
    // 福包管理
    {
      path: 'redPackit',
      name: 'RedPackit',
      component: '/malls/marketing/redPackit',
      meta: {
        keepAlive: true,
        title: 'MallsSet',
        isOnly: false,
        auth: [],
        pagePermission: [{
          title: 'RedPackit',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
        }]
      }
    },
    // 添加福包
    {
      path: 'addRedPackit',
      name: 'EditRedPackit',
      component: '/malls/marketing/addRedPackit',
      meta: {
        title: 'MallsSet',
        isOnly: false,
        auth: [],
        pagePermission: [{
          title: 'EditRedPackit',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
        }]
      }
    },
    // 交易设置
    {
      path: 'dealSet',
      name: 'DealSet',
      component: '/malls/set/deal',
      meta: {
        title: 'MallsSet',
        isOnly: false,
        auth: [],
        pagePermission: [{
          title: 'DealSet',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
        }]
      }
    },
    // 虚拟支付设置
    {
      path: 'virtualPayment',
      name: 'VirtualPaymentSet',
      component: '/malls/set/payment',
      meta: {
        title: 'MallsSet',
        isOnly: false,
        auth: [],
        pagePermission: [{
          title: 'VirtualPaymentSet',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
        }]
      }
    },
    // 商城轮播图
    {
      path: 'banner',
      name: 'MallsBanner',
      component: '/malls/set/banner',
      meta: {
        keepAlive: true,
        title: 'MallsSet',
        isOnly: false,
        auth: [],
        pagePermission: [{
          title: 'MallsBanner',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
        }]
      }
    },
    {
      path: 'editBanner',
      name: 'EditBanner',
      component: '/malls/set/editBanner',
      meta: {
        title: 'MallsSet',
        isOnly: false,
        auth: [],
        pagePermission: [{
          title: 'EditBanner',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
        }]
      }
    },
    // 员工选择商品
    {
      path: 'staffGoods',
      name: 'StaffChoiceGoods',
      component: '/malls/set/staffGoods',
      meta: {
        title: 'MallsSet',
        isOnly: false,
        auth: [],
        pagePermission: [{
          title: 'StaffChoiceGoods',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
        }]
      }
    },
    {
      path: 'paymentSetting',
      name: 'PaymentSetting',
      component: '/malls/set/paymentSetting',
      meta: {
        title: 'MallsSet',
        isOnly: false,
        auth: [],
        pagePermission: [{
          title: 'PaymentSetting',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
        }]
      }
    },
    // 分销
    {
      path: 'profit',
      component: '/malls/distribution/profit',
      name: 'ProfitInfo',
      meta: {
        title: 'MallsSet',
        auth: [],
        isOnly: false,
        keepAlive: true,
        pagePermission: [{
          title: 'ProfitInfo',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport']
        }]
      }
    },
    {
      path: 'commission',
      component: '/malls/distribution/commission',
      name: 'CommissionInfo',
      meta: {
        title: 'MallsSet',
        auth: [],
        isOnly: false,
        keepAlive: true,
        pagePermission: [{
          title: 'CommissionInfo',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport']
        }]
      }
    },
    {
      path: 'cash',
      component: '/malls/distribution/takeCash',
      name: 'TakeCashInfo',
      meta: {
        title: 'MallsSet',
        auth: [],
        isOnly: false,
        keepAlive: true,
        pagePermission: [{
          title: 'TakeCashInfo',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport']
        }]
      }
    },
    {
      path: 'cashSet',
      component: '/malls/distribution/cashSet',
      name: 'CashSet',
      meta: {
        title: 'MallsSet',
        auth: [],
        isOnly: false,
        keepAlive: true,
        pagePermission: [{
          title: 'CashSet',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport']
        }]
      }
    },
    {
      path: 'relation',
      component: '/malls/distribution/relation',
      name: 'DistributionRelation',
      meta: {
        title: 'MallsSet',
        auth: [],
        isOnly: false,
        keepAlive: true,
        pagePermission: [{
          title: 'DistributionRelation',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport']
        }]
      }
    },
    {
      path: 'disSet',
      component: '/malls/distribution/set',
      name: 'DistributionSetting',
      meta: {
        title: 'MallsSet',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'DistributionSetting',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport']
        }]
      }
    },
    {
      path: 'Audit',
      component: '/malls/distribution/audit',
      name: 'DistributionAudit',
      meta: {
        title: 'MallsSet',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'DistributionAudit',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport']
        }]
      }
    },
    {
      path: 'detailsaudit',
      component: '/malls/distribution/detailsaudit',
      name: 'DetailsAudit',
      meta: {
        title: 'MallsSet',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'DetailsAudit',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport']
        }]
      }
    }
  ]
},
// 动态
{
  path: '/dynamic',
  component: 'Layout',
  redirect: '/dynamic/manage',
  meta: {
    menuName: 'Dynamic',
    icon: 'icon-dongtai1',
    subNavName: [{
      name: 'DynamicManage', // 二级菜单的下拉的标题
      url: [{
        name: 'DynamicManage', // 三级菜单的标题
        url: '/dynamic/manage' // 三级菜单的路由
      },
      {
        name: 'CommentManage', // 三级菜单的标题
        url: '/dynamic/comment' // 三级菜单的路由
      },
      {
        name: 'DynamicClassifySet', // 三级菜单的标题
        url: '/dynamic/classifySet' // 三级菜单的路由
      }
      ]
    }]
  },
  children: [{
    path: 'manage',
    name: 'DynamicManage',
    component: '/dynamic/manage',
    meta: {
      title: 'DynamicSet',
      isOnly: false,
      auth: [],
      keepAlive: true,
      pagePermission: [{
        title: 'DynamicManage',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
      }]
    }
  },
  {
    path: 'comment',
    name: 'CommentManage',
    component: '/dynamic/comment',
    meta: {
      title: 'DynamicSet',
      isOnly: false,
      auth: [],
      keepAlive: true,
      pagePermission: [{
        title: 'CommentManage',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
      }]
    }
  },
  {
    path: 'classifySet',
    name: 'DynamicClassifySet',
    component: '/dynamic/classifySet',
    meta: {
      title: 'DynamicSet',
      isOnly: false,
      auth: [],
      keepAlive: true,
      pagePermission: [{
        title: 'DynamicClassifySet',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
      }]
    }
  },
  {
    path: 'editOrdinary',
    name: 'EditOrdinary',
    component: '/dynamic/addOrdinary',
    meta: {
      title: 'DynamicSet',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'EditOrdinary',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'editLink',
    name: 'EditLink',
    component: '/dynamic/addLink',
    meta: {
      title: 'DynamicSet',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'EditLink',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'editVideo',
    name: 'EditVideo',
    component: '/dynamic/addVideo',
    meta: {
      title: 'DynamicSet',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'EditVideo',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  }
  ]
},
// 官网
{
  path: '/website',
  component: 'Layout',
  redirect: '/website/column',
  meta: {
    menuName: 'Website',
    icon: 'icon-guanwang',
    subNavName: [{
      name: 'WebSiteInfo', // 产品管理
      url: [{
        name: 'WebsiteColumn',
        url: '/website/column'
      }]
    }]
  },
  children: [{
    path: 'column',
    name: 'WebsiteColumn', // 产品分类管理
    component: '/website/info/column',
    meta: {
      title: 'WebsiteManage',
      isOnly: false,
      keepAlive: true,
      auth: [],
      pagePermission: [{
        title: 'WebsiteColumn',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'editModule',
    name: 'EditModule',
    component: '/website/info/editModule',
    meta: {
      title: 'WebsiteManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'EditModule',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'newsList', // 新闻列表
    name: 'newsList',
    component: '/website/info/module/news',
    meta: {
      title: 'WebsiteManage',
      isOnly: false,
      keepAlive: true,
      auth: [],
      pagePermission: [{
        title: 'newsList',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'editNews', // 编辑新闻
    name: 'NewsEdit',
    component: '/website/info/module/newsEdit',
    meta: {
      title: 'WebsiteManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'NewsEdit',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'imgText', // 图文编辑
    name: 'imgText',
    component: '/website/info/module/imgText',
    meta: {
      title: 'WebsiteManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'imgText',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'recruit', // 招聘
    name: 'recruit',
    component: '/website/info/module/recruit',
    meta: {
      title: 'WebsiteManage',
      isOnly: false,
      auth: [],
      keepAlive: true,
      pagePermission: [{
        title: 'recruit',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'editRecruit', // 招聘编辑
    name: 'RecruitEdit',
    component: '/website/info/module/editRecruit',
    meta: {
      title: 'WebsiteManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'RecruitEdit',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'contact', // 联系
    name: 'contact',
    component: '/website/info/module/contact',
    meta: {
      title: 'WebsiteManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'contact',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'staff', // 员工
    name: 'staff',
    component: '/website/info/module/staff',
    meta: {
      title: 'WebsiteManage',
      isOnly: false,
      auth: [],
      keepAlive: true,
      pagePermission: [{
        title: 'staff',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'editStaff', // 员工
    name: 'EditStaff',
    component: '/website/info/module/addStaff',
    meta: {
      title: 'WebsiteManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'EditStaff',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'video', // 视频
    name: 'video',
    component: '/website/info/module/video',
    meta: {
      title: 'WebsiteManage',
      isOnly: false,
      auth: [],
      keepAlive: true,
      pagePermission: [{
        title: 'video',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'editVideo', // 视频
    name: 'VideoEdit',
    component: '/website/info/module/videoEdit',
    meta: {
      title: 'WebsiteManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'VideoEdit',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'form', // 表单
    name: 'form',
    component: '/website/info/module/form',
    meta: {
      title: 'WebsiteManage',
      isOnly: false,
      auth: [],
      keepAlive: true,
      pagePermission: [{
        title: 'form',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  }
  ]
},
// 客户
{
  path: '/customer',
  component: 'Layout',
  redirect: '/customer/list',
  meta: {
    menuName: 'Customer',
    icon: 'icon-kehu',
    subNavName: [{
      name: 'CustomerInfo',
      url: [{
        name: 'CustomerList',
        url: '/customer/list'
      },
      {
        name: 'StaffHandover',
        url: '/customer/handover'
      }
      ]
    },
    {
      name: 'CustomerTalkingSkill',
      url: [{
        name: 'TalkingSkillList',
        url: '/customer/talkingSkill'
      },
      {
        name: 'TalkingSkillClassify',
        url: '/customer/classify'
      }
      ]
    },
    {
      name: 'CustomerQuestionnaire',
      url: [{
        name: 'QuestionnaireList',
        url: '/customer/qList'
      },
      {
        name: 'QuestionnaireSetting',
        url: '/customer/qSetting'
      }
      ]
    }
    ]
  },
  children: [{
    path: 'list',
    component: '/customer/info/list',
    name: 'CustomerList',
    meta: {
      title: 'CustomerManagement',
      auth: [],
      isOnly: false,
      keepAlive: true,
      pagePermission: [{
        title: 'CustomerList',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'handover',
    component: '/customer/info/handover',
    name: 'StaffHandover',
    meta: {
      title: 'CustomerManagement',
      auth: [],
      isOnly: false,
      keepAlive: true,
      pagePermission: [{
        title: 'StaffHandover',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'talkingSkill',
    component: '/customer/talkingSkill/list',
    name: 'TalkingSkillList',
    meta: {
      title: 'CustomerManagement',
      auth: [],
      isOnly: false,
      keepAlive: true,
      pagePermission: [{
        title: 'TalkingSkillList',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'classify',
    component: '/customer/talkingSkill/classify',
    name: 'TalkingSkillClassify',
    meta: {
      title: 'CustomerManagement',
      auth: [],
      isOnly: false,
      keepAlive: true,
      pagePermission: [{
        title: 'TalkingSkillClassify',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'qList',
    component: '/customer/questionnaire/list',
    name: 'QuestionnaireList',
    meta: {
      title: 'CustomerManagement',
      auth: [],
      isOnly: false,
      keepAlive: true,
      pagePermission: [{
        title: 'QuestionnaireList',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'qEdit',
    component: '/customer/questionnaire/edit',
    name: 'QuestionnaireEdit',
    meta: {
      title: 'CustomerManagement',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'QuestionnaireEdit',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'qSetting',
    component: '/customer/questionnaire/setting',
    name: 'QuestionnaireSetting',
    meta: {
      title: 'CustomerManagement',
      auth: [],
      isOnly: false,
      keepAlive: true,
      pagePermission: [{
        title: 'QuestionnaireSetting',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'lookInto',
    component: '/customer/info/lookInto',
    name: 'CustomerLookInto',
    meta: {
      title: 'CustomerManagement',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'CustomerLookInto',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  }
  ]
},
// 公司
{
  path: '/company',
  component: 'Layout',
  redirect: '/company/list',
  meta: {
    menuName: 'Company',
    icon: 'icon-gongsi',
    subNavName: [{
      name: 'CompanyInfo',
      url: [{
        name: 'CompanyList',
        url: '/company/list'
      },
      {
        name: 'StoreQRCodeSet',
        url: '/company/qrcodeSet'
      }
      ]
    },
    {
      name: 'PostInfo',
      url: [{
        name: 'PostManage',
        url: '/company/postManage'
      }]
    }
    ]
  },
  children: [{
    path: 'addCompany',
    name: 'EditCompany',
    component: '/company/manage/addCompany',
    meta: {
      keepAlive: true,
      title: 'CompanyManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'EditCompany',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
      }]
    }
  },
  {
    path: 'qrcodeSet',
    name: 'StoreQRCodeSet',
    component: '/company/manage/qrcode',
    meta: {
      keepAlive: true,
      title: 'CompanyManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'StoreQRCodeSet',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
      }]
    }
  },
  {
    path: 'list',
    name: 'CompanyList',
    component: '/company/manage/list',
    meta: {
      keepAlive: true,
      title: 'CompanyManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'CompanyList',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
      }]
    }
  },
  {
    path: 'postManage',
    name: 'PostManage',
    component: '/company/manage/postManage',
    meta: {
      keepAlive: true,
      title: 'CompanyManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'PostManage',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport'] // 按钮操作权限
      }]
    }
  }
  ]
},
// 系统
{
  path: '/sys',
  component: 'Layout',
  redirect: '/sys/config',
  meta: {
    menuName: 'System',
    icon: 'icon-xitong',
    subNavName: [{
      name: 'SProSetting',
      url: [
        {
          name: 'SProConfig',
          url: '/sys/config'
        },
        {
          name: 'SProConfigtest',
          url: '/sys/configtest'
        },
        {
          name: 'SProLink',
          url: '/sys/link'
        }
      ]
    },
    {
      name: 'OtherSetting',
      url: [{
        name: 'CopyrightConfig',
        url: '/sys/copyright'
      },
      {
        name: 'AllNotice',
        url: '/sys/clientNotice'
      }
        // {
        //   name: 'UploadConfig',
        //   url: '/sys/upload'
        // }
      ]
    },
      // 新增的靳云服務
    {
      name: 'CloudService',
      url: [{
        name: 'ServiceCore',
        url: '/sys/servicecore'
      },
      {
        name: 'OrderRecord',
        url: '/sys/OrderRecord'
      },
      {
        name: 'InvoiceManage',
        url: '/sys/InvoiceManage'
      }
      ]
    },
    {
      name: 'compNews',
      url: [
        {
          name: 'compNews',
          url: '/sys/compNews'
        }
      ]
    }
    ]
  },
  children: [{
    path: 'config',
    name: 'SProConfig',
    component: '/system/smallProcedure/config',
    meta: {
      keepAlive: true,
      title: 'SystemSetting',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'SProConfig',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
    // 小程序配置测试
  {
    path: 'configtest',
    name: 'SProConfigtest',
    component: '/system/smallProcedure/configtest',
    meta: {
      keepAlive: true,
      title: 'SystemSetting',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'SProConfigtest',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'link',
    name: 'SProLink',
    component: '/system/smallProcedure/link',
    meta: {
      keepAlive: true,
      title: 'SystemSetting',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'SProLink',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'tabbar',
    name: 'TabbarSetting',
    component: '/system/smallProcedure/tabbar',
    meta: {
      keepAlive: true,
      title: 'SystemSetting',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'TabbarSetting',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'copyright',
    name: 'CopyrightConfig',
    component: '/system/other/copyright',
    meta: {
      keepAlive: true,
      title: 'SystemSetting',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'CopyrightConfig',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'upload',
    name: 'UploadConfig',
    component: '/system/other/uploadConfig',
    meta: {
      keepAlive: true,
      title: 'SystemSetting',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'UploadConfig',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'clientNotice',
    name: 'AllNotice',
    component: '/system/other/clientNotice',
    meta: {
      keepAlive: true,
      title: 'SystemSetting',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'clientNotice',
        url: '/sys/clientNotice',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
        // {
        //   title: 'radarNotice',
        //   url: '/sys/radarNotice',
        //   index: 1,
        //   auth: ['view', 'add', 'edit', 'del', 'outport']
        // }
      ]
    }
  },
    // 新增服务中心
  {
    path: 'servicecore',
    name: 'AllNotice',
    component: '/system/cloudService/ServiceCore',
    meta: {
      keepAlive: true,
      title: 'SystemSetting',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'ServiceCore',
        url: '/sys/ServiceCore',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
        // {
        //   title: 'radarNotice',
        //   url: '/sys/radarNotice',
        //   index: 1,
        //   auth: ['view', 'add', 'edit', 'del', 'outport']
        // }
      ]
    }
  },
    // 新增订购记录
  {
    path: 'InvoiceManage',
    name: 'AllNotice',
    component: '/system/cloudService/InvoiceManage',
    meta: {
      keepAlive: true,
      title: 'SystemSetting',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'InvoiceManage',
        url: '/sys/InvoiceManage',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
        // {
        //   title: 'radarNotice',
        //   url: '/sys/radarNotice',
        //   index: 1,
        //   auth: ['view', 'add', 'edit', 'del', 'outport']
        // }
      ]
    }
  },
    // 新增发票管理
  {
    path: 'OrderRecord',
    name: 'AllNotice',
    component: '/system/cloudService/OrderRecord',
    meta: {
      keepAlive: true,
      title: 'SystemSetting',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'OrderRecord',
        url: '/sys/OrderRecord',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
        // {
        //   title: 'radarNotice',
        //   url: '/sys/radarNotice',
        //   index: 1,
        //   auth: ['view', 'add', 'edit', 'del', 'outport']
        // }
      ]
    }
  },
  {
    path: 'radarNotice',
    name: 'AllNotice',
    component: '/system/other/radarNotice',
    meta: {
      keepAlive: true,
      title: 'SystemSetting',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'clientNotice',
        url: '/sys/clientNotice',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'radarNotice',
        url: '/sys/radarNotice',
        index: 1,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'site',
    name: 'SiteBinding',
    component: '/system/other/site',
    meta: {
      keepAlive: true,
      title: 'SystemSetting',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'SiteBinding',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
    // 公司信息
  {
    path: 'compNews',
    name: 'compNews',
    component: '/system/compNews/compNews',
    meta: {
      keepAlive: true,
      title: 'SystemSetting',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'compNews',
        url: '/sys/compNews',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
        // {
        //   title: 'radarNotice',
        //   url: '/sys/radarNotice',
        //   index: 1,
        //   auth: ['view', 'add', 'edit', 'del', 'outport']
        // }
      ]
    }
  }
  ]
},
// 案例图
{
  path: '/casepic',
  component: 'Layout',
  redirect: '/casepic/upload',
  meta: {
    menuName: 'casePic',
    icon: 'icontupian1',
    subNavName: [{
      name: 'casePic',
      url: [
        {
          name: 'uploadCasePic',
          url: '/casepic/upload'
        }
      ]
    }]
  },
  children: [
    {
      path: 'upload',
      name: 'casePic',
      component: '/casepic/upload',
      meta: {
        keepAlive: true,
        title: 'casePic',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'casePic',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport']
        }]
      }
    }
  ]
},
// 邀请有礼
{
  path: '/politeInvitation',
  component: 'Layout',
  redirect: '/politeInvitation/index',
  meta: {
    menuName: 'politeInvitation',
    icon: 'iconshezhi',
    subNavName: [{
      name: 'politeInvitation',
      url: [
        {
          name: 'politeInvitation',
          url: '/PoliteInvitation/index'
        }
      ]
    }]
  },
  children: [
    {
      path: 'index',
      name: 'politeInvitation',
      component: '/politeInvitation/index',
      meta: {
        keepAlive: true,
        title: 'politeInvitation',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'politeInvitation',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport']
        }]
      }
    }
  ]
},
// 账号管理
{
  path: '/account',
  component: 'Layout',
  redirect: '/account/list',
  meta: {
    menuName: 'AccountManager',
    icon: 'iconshezhi',
    subNavName: [{
      name: 'AccountManager',
      url: [
        {
          name: 'AccountManagerList',
          url: '/account/list'
        }
      ]
    }]
  },
  children: [
    {
      path: 'list',
      name: 'AccountManager',
      component: '/account/list',
      meta: {
        keepAlive: true,
        title: 'AccountManager',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'AccountManager',
          index: 0,
          auth: ['view', 'add', 'edit', 'del', 'outport']
        }]
      }
    }
  ]
},
// diy
{
  path: '/diy',
  component: 'Layout',
  redirect: '/diy/list',
  meta: {
    menuName: 'diy',
    icon: 'iconchaifenyemian',
    subNavName: [{
      name: 'diySub',
      url: [
        {
          name: 'diyList',
          url: '/diy/list'
        },
        {
          name: 'Colorset',
          url: '/diy/color'
        }
      ]
    }]
  },
  children: [{
    path: 'list',
    name: 'diyList',
    component: '/diy/list',
    meta: {
      keepAlive: true,
      title: 'diySub',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'diyList',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'edit',
    name: 'diySub',
    component: '/diy/edit',
    meta: {
      title: 'diySub',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'diySub',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'color',
    name: 'Colorset',
    component: '/diy/color',
    meta: {
      keepAlive: true,
      title: 'SystemSetting',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'Colorset',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  }
  ]
},
// 应用
{
  path: '/app',
  component: 'Layout',
  redirect: '/app/tool',
  meta: {
    menuName: 'App',
    img: require('@/assets/icon/apps.png'),
    subNavName: [{
      name: 'AppCenter',
      url: [{
        name: 'AppTool',
        url: '/app/tool'
      }]
    }]
  },
  children: [{
    path: 'tool',
    name: 'AppTool',
    component: '/application/tool',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'AppTool',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
    // 扫码支付
  {
    path: 'sweepPayment/code',
    name: 'SweepPaymentCode',
    component: '/application/sweepPayment/code',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'PaymentCode',
        url: '/app/sweepPayment/code',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'PaymentRecord',
        url: '/app/sweepPayment/record',
        index: 1,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'Swiper',
        url: '/app/sweepPayment/swiper',
        index: 2,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'BasicSetting',
        url: '/app/sweepPayment/setting',
        index: 3,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'sweepPayment/record',
    name: 'SweepPaymentRecord',
    component: '/application/sweepPayment/record',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'PaymentCode',
        url: '/app/sweepPayment/code',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'PaymentRecord',
        url: '/app/sweepPayment/record',
        index: 1,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'Swiper',
        url: '/app/sweepPayment/swiper',
        index: 2,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'BasicSetting',
        url: '/app/sweepPayment/setting',
        index: 3,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'sweepPayment/swiper',
    name: 'SweepPaymentSwiper',
    component: '/application/sweepPayment/swiper',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'PaymentCode',
        url: '/app/sweepPayment/code',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'PaymentRecord',
        url: '/app/sweepPayment/record',
        index: 1,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'Swiper',
        url: '/app/sweepPayment/swiper',
        index: 2,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'BasicSetting',
        url: '/app/sweepPayment/setting',
        index: 3,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'sweepPayment/setting',
    name: 'SweepPaymentSetting',
    component: '/application/sweepPayment/setting',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'PaymentCode',
        url: '/app/sweepPayment/code',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'PaymentRecord',
        url: '/app/sweepPayment/record',
        index: 1,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'Swiper',
        url: '/app/sweepPayment/swiper',
        index: 2,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'BasicSetting',
        url: '/app/sweepPayment/setting',
        index: 3,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'sweepPayment/addSwiper',
    name: 'SweepPaymentAddSwiper',
    component: '/application/sweepPayment/addSwiper',
    meta: {
      title: 'AppManage',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'EditSwiper',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
    // 获客海报
  {
    path: 'poster/classify',
    name: 'GuestWinningPosterClassify',
    component: '/application/poster/classify',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'PosterClassify',
        url: '/app/poster/classify',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'PosterList',
        url: '/app/poster/list',
        index: 1,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'poster/list',
    name: 'GuestWinningPosterList',
    component: '/application/poster/list',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'PosterClassify',
        url: '/app/poster/classify',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'PosterList',
        url: '/app/poster/list',
        index: 1,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'poster/edit',
    name: 'GuestWinningPosterEdit',
    component: '/application/poster/editPoster',
    meta: {
      title: 'AppManage',
      auth: [],
      isOnly: false,
      pagePermission: [{
        title: 'EditPoster',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
    // 群发
  {
    path: 'group/msg',
    name: 'GMsg',
    component: '/application/groupPush/msg',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'GMsg',
        index: 0,
        url: '/app/group/msg',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'GNews',
        url: '/app/group/news',
        index: 1,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'ContentSetting',
        url: '/app/group/setting',
        index: 2,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'group/news',
    name: 'GNews',
    component: '/application/groupPush/news',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'GMsg',
        index: 0,
        url: '/app/group/msg',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'GNews',
        url: '/app/group/news',
        index: 1,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'ContentSetting',
        url: '/app/group/setting',
        index: 2,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'group/setting',
    name: 'ContentSetting',
    component: '/application/groupPush/setting',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'GMsg',
        index: 0,
        url: '/app/group/msg',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'GNews',
        url: '/app/group/news',
        index: 1,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'ContentSetting',
        url: '/app/group/setting',
        index: 2,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
    // 预约
  {
    path: 'appointment/classify',
    name: 'ServiceClassify',
    component: '/application/appointment/classifyList',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'ServiceClassify',
        index: 0,
        url: '/app/appointment/classify',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'AppointmentService',
        url: '/app/appointment/service',
        index: 1,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'GuestOrder',
        url: '/app/appointment/order',
        index: 2,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'AppointmentSetting',
        url: '/app/appointment/setting',
        index: 3,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'appointment/editService',
    name: 'AddService',
    component: '/application/appointment/editService',
    meta: {
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'ServiceClassify',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'appointment/order',
    name: 'GuestOrder',
    component: '/application/appointment/order',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'ServiceClassify',
        index: 0,
        url: '/app/appointment/classify',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'AppointmentService',
        url: '/app/appointment/service',
        index: 1,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'GuestOrder',
        url: '/app/appointment/order',
        index: 2,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'AppointmentSetting',
        url: '/app/appointment/setting',
        index: 3,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'appointment/service',
    name: 'AppointmentService',
    component: '/application/appointment/serviceList',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'ServiceClassify',
        index: 0,
        url: '/app/appointment/classify',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'AppointmentService',
        url: '/app/appointment/service',
        index: 1,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'GuestOrder',
        url: '/app/appointment/order',
        index: 2,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'AppointmentSetting',
        url: '/app/appointment/setting',
        index: 3,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'appointment/setting',
    name: 'AppointmentSetting',
    component: '/application/appointment/setting',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'ServiceClassify',
        index: 0,
        url: '/app/appointment/classify',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'AppointmentService',
        url: '/app/appointment/service',
        index: 1,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'GuestOrder',
        url: '/app/appointment/order',
        index: 2,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'AppointmentSetting',
        url: '/app/appointment/setting',
        index: 3,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
    // 房产
  {
    path: 'house/classify',
    name: 'HouseClassify',
    component: '/application/houseProperty/classify',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'HouseClassify',
        index: 0,
        url: '/app/house/classify',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'HouseBanner',
        url: '/app/house/banner',
        index: 1,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'HouseManage',
        url: '/app/house/manage',
        index: 2,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'HouseScreenManage',
        url: '/app/house/screen',
        index: 3,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'HouseAppointmentCustomer',
        url: '/app/house/customer',
        index: 4,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'house/banner',
    name: 'HouseBanner',
    component: '/application/houseProperty/banner',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'HouseClassify',
        index: 0,
        url: '/app/house/classify',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'HouseBanner',
        url: '/app/house/banner',
        index: 1,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'HouseManage',
        url: '/app/house/manage',
        index: 2,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'HouseScreenManage',
        url: '/app/house/screen',
        index: 3,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'HouseAppointmentCustomer',
        url: '/app/house/customer',
        index: 4,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'house/manage',
    name: 'HouseManage',
    component: '/application/houseProperty/manage',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'HouseClassify',
        index: 0,
        url: '/app/house/classify',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'HouseBanner',
        url: '/app/house/banner',
        index: 1,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'HouseManage',
        url: '/app/house/manage',
        index: 2,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'HouseScreenManage',
        url: '/app/house/screen',
        index: 3,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'HouseAppointmentCustomer',
        url: '/app/house/customer',
        index: 4,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'house/screen',
    name: 'HouseScreenManage',
    component: '/application/houseProperty/screen',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'HouseClassify',
        index: 0,
        url: '/app/house/classify',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'HouseBanner',
        url: '/app/house/banner',
        index: 1,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'HouseManage',
        url: '/app/house/manage',
        index: 2,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'HouseScreenManage',
        url: '/app/house/screen',
        index: 3,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'HouseAppointmentCustomer',
        url: '/app/house/customer',
        index: 4,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'house/customer',
    name: 'HouseAppointmentCustomer',
    component: '/application/houseProperty/customer',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'HouseClassify',
        index: 0,
        url: '/app/house/classify',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'HouseBanner',
        url: '/app/house/banner',
        index: 1,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'HouseManage',
        url: '/app/house/manage',
        index: 2,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'HouseScreenManage',
        url: '/app/house/screen',
        index: 3,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'HouseAppointmentCustomer',
        url: '/app/house/customer',
        index: 4,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'house/editClassify',
    name: 'EditHouseClassify',
    component: '/application/houseProperty/editClassify',
    meta: {
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'EditHouseClassify',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'house/editBanner',
    name: 'EditHouseBanner',
    component: '/application/houseProperty/editBanner',
    meta: {
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'EditHouseBanner',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'house/editHouse',
    name: 'EditHouse',
    component: '/application/houseProperty/editHouse',
    meta: {
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'EditHouse',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
    // 预约活动
  {
    path: 'activity/classify',
    name: 'ActivityClassify',
    component: '/application/activity/classify',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'ActivityClassify',
        index: 0,
        url: '/app/activity/classify',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
        {
          title: 'SignUpContent',
          url: '/app/activity/content',
          index: 1,
          auth: ['view', 'add', 'edit', 'del', 'outport']
        },
        {
          title: 'ActivityGroupManage',
          url: '/app/activity/manageGroup',
          index: 2,
          auth: ['view', 'add', 'edit', 'del', 'outport']
        },
        {
          title: 'ActivityManage',
          url: '/app/activity/manage',
          index: 3,
          auth: ['view', 'add', 'edit', 'del', 'outport']
        },
        {
          title: 'UserManage',
          url: '/app/activity/userManage',
          index: 4,
          auth: ['view', 'add', 'edit', 'del', 'outport']
        }
      ]
    }
  },
  {
    path: 'activity/content',
    name: 'SignUpContent',
    component: '/application/activity/content',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'ActivityClassify',
        index: 0,
        url: '/app/activity/classify',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
        {
          title: 'SignUpContent',
          url: '/app/activity/content',
          index: 1,
          auth: ['view', 'add', 'edit', 'del', 'outport']
        },
        {
          title: 'ActivityGroupManage',
          url: '/app/activity/manageGroup',
          index: 2,
          auth: ['view', 'add', 'edit', 'del', 'outport']
        },
        {
          title: 'ActivityManage',
          url: '/app/activity/manage',
          index: 3,
          auth: ['view', 'add', 'edit', 'del', 'outport']
        },
        {
          title: 'UserManage',
          url: '/app/activity/userManage',
          index: 4,
          auth: ['view', 'add', 'edit', 'del', 'outport']
        }
      ]
    }
  },
  {
    path: 'activity/manageGroup',
    name: 'ActivityGroupManage',
    component: '/application/activity/groupList',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'ActivityClassify',
        index: 0,
        url: '/app/activity/classify',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
        {
          title: 'SignUpContent',
          url: '/app/activity/content',
          index: 1,
          auth: ['view', 'add', 'edit', 'del', 'outport']
        },
        {
          title: 'ActivityGroupManage',
          url: '/app/activity/manageGroup',
          index: 2,
          auth: ['view', 'add', 'edit', 'del', 'outport']
        },
        {
          title: 'ActivityManage',
          url: '/app/activity/manage',
          index: 3,
          auth: ['view', 'add', 'edit', 'del', 'outport']
        },
        {
          title: 'UserManage',
          url: '/app/activity/userManage',
          index: 4,
          auth: ['view', 'add', 'edit', 'del', 'outport']
        }
      ]
    }
  },
  {
    path: 'activity/manage',
    name: 'ActivityManage',
    component: '/application/activity/list',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
          title: 'ActivityClassify',
          index: 0,
          url: '/app/activity/classify',
          auth: ['view', 'add', 'edit', 'del', 'outport']
        },
        {
          title: 'SignUpContent',
          url: '/app/activity/content',
          index: 1,
          auth: ['view', 'add', 'edit', 'del', 'outport']
        },
        {
          title: 'ActivityGroupManage',
          url: '/app/activity/manageGroup',
          index: 2,
          auth: ['view', 'add', 'edit', 'del', 'outport']
        },
        {
          title: 'ActivityManage',
          url: '/app/activity/manage',
          index: 3,
          auth: ['view', 'add', 'edit', 'del', 'outport']
        },
        {
          title: 'UserManage',
          url: '/app/activity/userManage',
          index: 4,
          auth: ['view', 'add', 'edit', 'del', 'outport']
        }
      ]
    }
  },
  {
    path: 'activity/userManage',
    name: 'UserManage',
    component: '/application/activity/user',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'ActivityClassify',
        index: 0,
        url: '/app/activity/classify',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
        {
          title: 'SignUpContent',
          url: '/app/activity/content',
          index: 1,
          auth: ['view', 'add', 'edit', 'del', 'outport']
        },
        {
          title: 'ActivityGroupManage',
          url: '/app/activity/manageGroup',
          index: 2,
          auth: ['view', 'add', 'edit', 'del', 'outport']
        },
        {
          title: 'ActivityManage',
          url: '/app/activity/manage',
          index: 3,
          auth: ['view', 'add', 'edit', 'del', 'outport']
        },
        {
          title: 'UserManage',
          url: '/app/activity/userManage',
          index: 4,
          auth: ['view', 'add', 'edit', 'del', 'outport']
        }
      ]
    }
  },
  {
    path: 'activity/edit',
    name: 'EditActivity',
    component: '/application/activity/edit',
    meta: {
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'EditActivity',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'activity/advancedTools',
    name: 'advancedTools',
    component: '/application/activity/advancedTools',
    meta: {
      title: 'AppManage',
      isOnly: false,
      auth: [],
      keepAlive: true,
      pagePermission: [{
        title: 'advancedTools',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'activity/editGroup',
    name: 'EditActivityGroup',
    component: '/application/activity/editGroup',
    meta: {
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'EditActivityGroup',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'activity/signUp',
    name: 'SignUpDetail',
    component: '/application/activity/signUp',
    meta: {
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'SignUpDetail',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'activity/signUpAb',
    name: 'SignUpDetailAb',
    component: '/application/activity/signUpAb',
    meta: {
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'SignUpDetailAb',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'activity/activityList',
    name: 'ActivityList',
    component: '/application/activity/activityList',
    meta: {
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'ActivityList',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
    // 获客文章
  {
    path: 'article/classify',
    name: 'ArticleClassify',
    component: '/application/article/classify',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'ArticleClassify',
        index: 0,
        url: '/app/article/classify',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'ArticleList',
        url: '/app/article/list',
        index: 1,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'StaffArticle',
        url: '/app/article/staff',
        index: 2,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'ArticleSetting',
        url: '/app/article/setting',
        index: 3,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'AssignedArticle',
        url: '/app/article/assigne',
        index: 4,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'article/list',
    name: 'ArticleList',
    component: '/application/article/articleList',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'ArticleClassify',
        index: 0,
        url: '/app/article/classify',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'ArticleList',
        url: '/app/article/list',
        index: 1,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'StaffArticle',
        url: '/app/article/staff',
        index: 2,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'ArticleSetting',
        url: '/app/article/setting',
        index: 3,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'AssignedArticle',
        url: '/app/article/assigne',
        index: 4,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'article/staff',
    name: 'StaffArticle',
    component: '/application/article/staffArticleList',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'ArticleClassify',
        index: 0,
        url: '/app/article/classify',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'ArticleList',
        url: '/app/article/list',
        index: 1,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'StaffArticle',
        url: '/app/article/staff',
        index: 2,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'ArticleSetting',
        url: '/app/article/setting',
        index: 3,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'AssignedArticle',
        url: '/app/article/assigne',
        index: 4,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'article/setting',
    name: 'ArticleSetting',
    component: '/application/article/setting',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'ArticleClassify',
        index: 0,
        url: '/app/article/classify',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'ArticleList',
        url: '/app/article/list',
        index: 1,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'StaffArticle',
        url: '/app/article/staff',
        index: 2,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'ArticleSetting',
        url: '/app/article/setting',
        index: 3,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'AssignedArticle',
        url: '/app/article/assigne',
        index: 4,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'article/assigne',
    name: 'AssignedArticle',
    component: '/application/article/assignedArticle',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'ArticleClassify',
        index: 0,
        url: '/app/article/classify',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'ArticleList',
        url: '/app/article/list',
        index: 1,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'StaffArticle',
        url: '/app/article/staff',
        index: 2,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'ArticleSetting',
        url: '/app/article/setting',
        index: 3,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'AssignedArticle',
        url: '/app/article/assigne',
        index: 4,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'article/edit',
    name: 'EditArticle',
    component: '/application/article/editArticle',
    meta: {
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'EditArticle',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'baidu/setting',
    name: 'BaiduSetting',
    component: '/application/baidu/setting',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'BaiduSetting',
        index: 0,
        url: '/app/baidu/setting',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'bytedance/setting',
    name: 'BytedanceSetting',
    component: '/application/bytedance/setting',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'BytedanceSetting',
        index: 0,
        url: '/app/bytedance/setting',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'drainage/setting',
    name: 'DrainageSetting',
    component: '/application/drainage/setting',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'DrainageSetting',
        index: 0,
        url: '/app/drainage/setting',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'live/livebringgoods',
    name: 'LiveBringGoods',
    component: '/application/live/livebringgoods',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'LiveBringGoods',
        index: 0,
        url: '/app/live/livebringgoods',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'Instructions',
        index: 0,
        url: '/app/live/instructions',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'live/instructions',
    name: 'Instructions',
    component: '/application/live/instructions',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'LiveBringGoods',
        index: 0,
        url: '/app/live/livebringgoods',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'Instructions',
        index: 0,
        url: '/app/live/instructions',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'integralshop/instructions',
    name: 'Instructions',
    component: '/application/integralshop/instructions',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'Instructions',
        index: 0,
        url: '/app/integralshop/instructions',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'IntegralRecord',
        index: 0,
        url: '/app/integralshop/integralrecord',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'WonRecord',
        index: 0,
        url: '/app/integralshop/wonrecord',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'IntegralSetting',
        index: 0,
        url: '/app/integralshop/integralsetting',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'LotterySetting',
        index: 0,
        url: '/app/integralshop/lotterysetting',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'integralshop/integralrecord',
    name: 'IntegralRecord',
    component: '/application/integralshop/integralrecord',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'Instructions',
        index: 0,
        url: '/app/integralshop/instructions',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'IntegralRecord',
        index: 0,
        url: '/app/integralshop/integralrecord',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'WonRecord',
        index: 0,
        url: '/app/integralshop/wonrecord',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'IntegralSetting',
        index: 0,
        url: '/app/integralshop/integralsetting',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'LotterySetting',
        index: 0,
        url: '/app/integralshop/lotterysetting',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'integralshop/wonrecord',
    name: 'WonRecord',
    component: '/application/integralshop/wonrecord',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'Instructions',
        index: 0,
        url: '/app/integralshop/instructions',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'IntegralRecord',
        index: 0,
        url: '/app/integralshop/integralrecord',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'WonRecord',
        index: 0,
        url: '/app/integralshop/wonrecord',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'IntegralSetting',
        index: 0,
        url: '/app/integralshop/integralsetting',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'LotterySetting',
        index: 0,
        url: '/app/integralshop/lotterysetting',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'integralshop/integralsetting',
    name: 'IntegralSetting',
    component: '/application/integralshop/integralsetting',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'Instructions',
        index: 0,
        url: '/app/integralshop/instructions',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'IntegralRecord',
        index: 0,
        url: '/app/integralshop/integralrecord',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'WonRecord',
        index: 0,
        url: '/app/integralshop/wonrecord',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'IntegralSetting',
        index: 0,
        url: '/app/integralshop/integralsetting',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'LotterySetting',
        index: 0,
        url: '/app/integralshop/lotterysetting',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'integralshop/lotterysetting',
    name: 'LotterySetting',
    component: '/application/integralshop/lotterysetting',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'Instructions',
        index: 0,
        url: '/app/integralshop/instructions',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'IntegralRecord',
        index: 0,
        url: '/app/integralshop/integralrecord',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'WonRecord',
        index: 0,
        url: '/app/integralshop/wonrecord',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'IntegralSetting',
        index: 0,
        url: '/app/integralshop/integralsetting',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      },
      {
        title: 'LotterySetting',
        index: 0,
        url: '/app/integralshop/lotterysetting',
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }
      ]
    }
  },
  {
    path: 'customerarchives/clientManage',
    name: 'ClientManage',
    component: '/application/customerarchives/clientManage',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [
        {
          title: 'ClientManage',
          index: 0,
          url: '/app/customerarchives/clientManage',
          auth: ['view', 'add', 'edit', 'del', 'outport']
        },
        {
          title: 'IndicatorClassify',
          index: 0,
          url: '/app/customerarchives/indicatorClassify',
          auth: ['view', 'add', 'edit', 'del', 'outport']
        },
        {
          title: 'IndicatorTemplate',
          index: 0,
          url: '/app/customerarchives/indicatorTemplate',
          auth: ['view', 'add', 'edit', 'del', 'outport']
        },
        {
          title: 'TitleManage',
          index: 0,
          url: '/app/customerarchives/titleManage',
          auth: ['view', 'add', 'edit', 'del', 'outport']
        }
      ]
    }
  },
  {
    path: 'customerarchives/indicatorClassify',
    name: 'IndicatorClassify',
    component: '/application/customerarchives/indicatorClassify',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [
        {
          title: 'ClientManage',
          index: 0,
          url: '/app/customerarchives/clientManage',
          auth: ['view', 'add', 'edit', 'del', 'outport']
        },
        {
          title: 'IndicatorClassify',
          index: 0,
          url: '/app/customerarchives/indicatorClassify',
          auth: ['view', 'add', 'edit', 'del', 'outport']
        },
        {
          title: 'IndicatorTemplate',
          index: 0,
          url: '/app/customerarchives/indicatorTemplate',
          auth: ['view', 'add', 'edit', 'del', 'outport']
        },
        {
          title: 'TitleManage',
          index: 0,
          url: '/app/customerarchives/titleManage',
          auth: ['view', 'add', 'edit', 'del', 'outport']
        }
      ]
    }
  },
  {
    path: 'customerarchives/indicatorTemplate',
    name: 'IndicatorTemplate',
    component: '/application/customerarchives/indicatorTemplate',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [
        {
          title: 'ClientManage',
          index: 0,
          url: '/app/customerarchives/clientManage',
          auth: ['view', 'add', 'edit', 'del', 'outport']
        },
        {
          title: 'IndicatorClassify',
          index: 0,
          url: '/app/customerarchives/indicatorClassify',
          auth: ['view', 'add', 'edit', 'del', 'outport']
        },
        {
          title: 'IndicatorTemplate',
          index: 0,
          url: '/app/customerarchives/indicatorTemplate',
          auth: ['view', 'add', 'edit', 'del', 'outport']
        },
        {
          title: 'TitleManage',
          index: 0,
          url: '/app/customerarchives/titleManage',
          auth: ['view', 'add', 'edit', 'del', 'outport']
        }
      ]
    }
  },
  {
    path: 'customerarchives/titleManage',
    name: 'TitleManage',
    component: '/application/customerarchives/titleManage',
    meta: {
      keepAlive: true,
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [
        {
          title: 'ClientManage',
          index: 0,
          url: '/app/customerarchives/clientManage',
          auth: ['view', 'add', 'edit', 'del', 'outport']
        },
        {
          title: 'IndicatorClassify',
          index: 0,
          url: '/app/customerarchives/indicatorClassify',
          auth: ['view', 'add', 'edit', 'del', 'outport']
        },
        {
          title: 'IndicatorTemplate',
          index: 0,
          url: '/app/customerarchives/indicatorTemplate',
          auth: ['view', 'add', 'edit', 'del', 'outport']
        },
        {
          title: 'TitleManage',
          index: 0,
          url: '/app/customerarchives/titleManage',
          auth: ['view', 'add', 'edit', 'del', 'outport']
        }
      ]
    }
  },
  {
    path: 'customerarchives/editclient',
    name: 'EditClient',
    component: '/application/customerarchives/editClient',
    meta: {
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'EditClient',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'customerarchives/importClient',
    name: 'ImportClient',
    component: '/application/customerarchives/importClient',
    meta: {
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'ImportClient',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'customerarchives/indicatorClassifyEdit',
    name: 'EditIndicatorClassify',
    component: '/application/customerarchives/indicatorClassifyEdit',
    meta: {
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'EditIndicatorClassify',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'customerarchives/indicatorTemplateEdit',
    name: 'EditIndicatorTemplate',
    component: '/application/customerarchives/indicatorTemplateEdit',
    meta: {
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'EditIndicatorTemplate',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'customerarchives/serviceProgramme',
    name: 'ServiceProgramme',
    component: '/application/customerarchives/serviceProgramme',
    meta: {
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'ServiceProgramme',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'customerarchives/serviceProgrammeEdit',
    name: 'EditServiceProgramme',
    component: '/application/customerarchives/serviceProgrammeEdit',
    meta: {
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'EditServiceProgramme',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'customerarchives/serviceProgrammeDetail',
    name: 'DetailServiceProgramme',
    component: '/application/customerarchives/serviceProgrammeDetail',
    meta: {
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'DetailServiceProgramme',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'customerarchives/indicatorRecord',
    name: 'IndicatorRecord',
    component: '/application/customerarchives/indicatorRecord',
    meta: {
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'IndicatorRecord',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'customerarchives/indicatorRecordEdit',
    name: 'EditIndicatorRecord',
    component: '/application/customerarchives/indicatorRecordEdit',
    meta: {
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'EditIndicatorRecord',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'customerarchives/indicatorRecordDetail',
    name: 'DetailIndicatorRecord',
    component: '/application/customerarchives/indicatorRecordDetail',
    meta: {
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'DetailIndicatorRecord',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'customerarchives/serviceRecord',
    name: 'ServiceRecord',
    component: '/application/customerarchives/serviceRecord',
    meta: {
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'ServiceRecord',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'customerarchives/serviceRecordEdit',
    name: 'EditServiceRecord',
    component: '/application/customerarchives/serviceRecordEdit',
    meta: {
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'EditServiceRecord',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'customerarchives/contract',
    name: 'Contract',
    component: '/application/customerarchives/contract',
    meta: {
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'Contract',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  },
  {
    path: 'customerarchives/contractEdit',
    name: 'EditContract',
    component: '/application/customerarchives/contractEdit',
    meta: {
      title: 'AppManage',
      isOnly: false,
      auth: [],
      pagePermission: [{
        title: 'EditContract',
        index: 0,
        auth: ['view', 'add', 'edit', 'del', 'outport']
      }]
    }
  }
  ]
},
{
  path: '*',
  redirect: '/404',
  hidden: true
}
]



// WEBPACK FOOTER //
// ./src/permission.js